export default __webpack_public_path__ + "static/icon-15-5-6c65a3e9d2a22af526175b96c4eed45f.png";